<template>
  <div class="page-content">
    <div class="caozuo_div">
      <el-input v-model="userName" placeholder="请输入玩家名称"></el-input>
      <div class="inanniu_div">
        <el-select clearable v-model="value" placeholder="请选择状态">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="obtainData">搜索</el-button>
      </div>
    </div>
    <div class="anniu_div">
      <el-button type="primary" @click="clearCont">清除内容</el-button>
      <el-button type="primary" @click="creatOrder">创建订单</el-button>
    </div>

    <div class="neirong_div">
      <el-empty description="暂无数据" v-show="emptyShow"></el-empty>
      <app-data-display :Operation="Operation" :Datas="obtainorderlist" :Showheader="header" @lookup="lookupClick"
        @process="processClick" @deletes="deletesClick"></app-data-display>
    </div>

    <ModalEI v-if="showModal" v-model:visible="showModal" v-model:titleValue="titleValue" @close="showModal = false">
      <AppCreatOrder @save="onSave" @close="showModal = false" v-model:typePage="typePage" v-model:Datas="lookupData" />
    </ModalEI>
  </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行
import { processPageConfig } from './mainSTconfig';

export default {
  name: 'ProcessPage',
  props: {
    datainfo: {
      type: Object,
      default: () => ({ types: "", isOnUserClick: true })  // {"types": 包含[all,dzf,yzf,zfz,gq,sx,tk,wtj], "isOnUserClick": false}
    },
    searchNow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      types: "",
      userName: "",
      options: processPageConfig.options,
      value: this.datainfo?.isOnUserClick ? '' : this.datainfo?.types,
      emptyShow: true,
      obtainorderlist: [],
      header: processPageConfig.appDataDisplay_header,
      Operation: true,
      typePage: "",
      titleValue: "",
      showModal: false,
      lookupData: {}
    }
  },
  methods: {
    async obtainData() {
      try {
        if (this.value == processPageConfig.options[0].value) {
          this.value = "";
        }
        // 自动带 Token，自动处理错误
        const res = await request.post('/ObtainOrderListData', {
          Orderstate: this.value,
          Typeform: '率土',
          ApplicationUser: this.userName
        });

        // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
        this.$messageX.xiaoxiti("c", res.message);
        if (res.response.length > 0) {
          this.emptyShow = false;
        } else {
          this.emptyShow = true;
        }
        this.obtainorderlist = res.response;

      } catch (err) {
        // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
        this.emptyShow = true;
        console.log('失败:', err)
        if (err.response.data.message) {
          this.$messageX.xiaoxiti("e", err.response.data.message);
        } else {
          this.$messageX.xiaoxiti("e", err.message);
        }
      }
    },
    lookupClick(datas) {
      this.typePage = 'look';
      this.showModal = true;
      this.titleValue = '查看';
      this.lookupData = datas;
    },
    async processClick(datas) {
      if (datas.Orderstate == '待支付') {
        let re = confirm(`请确定用户【${datas.ApplicationUser}】已经添加了客服的微信！`);
        if (re) {
          try {
            // 自动带 Token，自动处理错误
            const res = await request.post('/QrCodeVerify', {
              qrCodeText: datas.ID
            });

            // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
            this.$messageX.xiaoxiti("c", res.message);
            this.value = res.response.Orderstate;
            this.userName = res.response.ApplicationUser;
            this.obtainData();

          } catch (err) {
            // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
            console.log('失败:', err)
            if (err.response.data.message) {
              this.$messageX.xiaoxiti("e", err.response.data.message);
            } else {
              this.$messageX.xiaoxiti("e", err.message);
            }
          }
        } else {
          return;
        }
      } else if (datas.Orderstate == '支付中') {
        let re = confirm(`请确定用户【${datas.ApplicationUser}】已经支付相应金额！`);
        if (re) {
          try {
            // 自动带 Token，自动处理错误
            const res = await request.post('/ModifyOrderState', {
              OrderID: datas.ID,
              UserName: datas.ApplicationUser,
              State: processPageConfig.options[3].label
            });

            // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
            this.$messageX.xiaoxiti("c", res.message);
            this.value = res.response.Orderstate;
            this.userName = res.response.ApplicationUser;
            this.obtainData();

          } catch (err) {
            // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
            console.log('失败:', err)
            if (err.response.data.message) {
              this.$messageX.xiaoxiti("e", err.response.data.message);
            } else {
              this.$messageX.xiaoxiti("e", err.message);
            }
          }
        } else {
          return;
        }
      }
    },
    async deletesClick(datas) {
      try {
        let re = confirm("确定删除这条订单？");
        if (re == false) {
          return;
        }
        // 自动带 Token，自动处理错误
        const res = await request.post('/DeleteOrder', {
          ID: datas.ID
        });

        // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
        this.$messageX.xiaoxiti("c", res.message);
        this.value = datas.Orderstate;
        this.userName = datas.ApplicationUser;
        this.obtainData();

      } catch (err) {
        // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
        console.log('失败:', err)
        if (err.response.data.message) {
          this.$messageX.xiaoxiti("e", err.response.data.message);
        } else {
          this.$messageX.xiaoxiti("e", err.message);
        }
      }
    },
    clearCont() {
      this.value = "";
      this.userName = "";
    },
    onSave(data) {
      console.log(data);
      this.userName = data.userName;
      this.value = "待支付";
      this.obtainData();
    },
    creatOrder() {
      this.typePage = "add";
      this.showModal = true;
      this.titleValue = "创建订单";
    }
  },
  mounted() {
    if (this.searchNow) {
      this.obtainData();
    }
  }
}
</script>

<style scoped>
.page-content {
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;
  display: flex;
  align-items: center;
}

.anniu_div {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: flex-end;
  padding: 0 10px 0 10px;
}

.caozuo_div {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0px 10px 0px 10px;
}

.neirong_div {
  width: 100%;
  height: calc(100% - 140px);
  overflow: auto;
  background-color: rgb(229, 229, 229);
}

.inanniu_div {
  display: flex;
  flex-direction: row;
}
</style>